document.addEventListener("DOMContentLoaded", () => {

    let quickAddDrawer = document.querySelector('#Main-Cart-Details')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                   BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

    let quickAddDrawer1 = document.querySelector('#Cart-Drawer-Details')
    if (quickAddDrawer1) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                   BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(quickAddDrawer1, {
            childList: true
        });
    }

   
});